import React, { useEffect, useState } from 'react';
import { api } from '../../api/client';

import { ta, adminLocale } from '../../i18n/adminT';
function formatDateTime(iso) {
  const d = new Date(iso);
  return d.toLocaleString(adminLocale(), {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
}

export default function LoginLogViewer() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    api.getLoginLog()
      .then((res) => { if (mounted) setRows(res.data); })
      .catch((err) => { if (mounted) setError(err.message); })
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, []);

  return (
    <div>
      <h1 className="admin-page-title">{ta('Accessi al pannello')}</h1>
      <p className="admin-page-subtitle">
        {ta('Chi si è collegato al pannello amministratore, da quale indirizzo IP pubblico e quando. Solo gli accessi riusciti (gli ultimi 200).')}
      </p>

      {error && <div className="form-error">{error}</div>}

      <div className="admin-card">
        {loading ? (
          <p style={{ color: 'var(--muted-text)' }}>{ta('Caricamento…')}</p>
        ) : rows.length === 0 ? (
          <p style={{ color: 'var(--muted-text)' }}>{ta('Nessun accesso registrato ancora.')}</p>
        ) : (
          <table className="admin-table">
            <thead>
              <tr>
                <th>{ta('Utente')}</th>
                <th>{ta('IP pubblico')}</th>
                <th>{ta('Data e ora')}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id}>
                  <td>{r.username}</td>
                  <td className="mono">{r.ip_address || '—'}</td>
                  <td className="mono">{formatDateTime(r.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
